export const dbPanels = {
  images: {
    subtitle: `Dodawaj, zmieniaj kolejność i ustawiaj główne zdjęcie każdej jednostki widocznej w silniku rezerwacji.`,
  },

  amenities: {
    searchPlaceholder: `Szukaj udogodnienia…`,
    selectedCount: `wybrano {count} udogodnienie | wybrano {count} udogodnienia | wybrano {count} udogodnień`,
    noResults: `Brak wyników dla "{query}".`,
    // Fotos por comodidad: lo que el Agente IA le enseña al huésped.
    photos: {
      explain: `Agent pokaże je gościowi, który zapyta o to udogodnienie.`,
      dropTitle: `Przeciągnij tutaj zdjęcia`,
      addPhotos: `Dodaj zdjęcia`,
      dropHint: `JPG, PNG, WebP lub HEIC · do {mb} MB każde`,
      dropActive: `Upuść, aby wysłać`,
      uploading: `Wysyłanie… {progress}%`,
      uploaded: `dodano {count} zdjęcie | dodano {count} zdjęcia | dodano {count} zdjęć`,
      counter: `{count} zdjęcie | {count} zdjęcia | {count} zdjęć`,
      remaining: `Możesz dodać jeszcze {count} zdjęcie | Możesz dodać jeszcze {count} zdjęcia | Możesz dodać jeszcze {count} zdjęć`,
      full: `Osiągnięto maksimum {max} zdjęć`,
      tooMany: `Na jedno udogodnienie przypada maksymalnie {max} zdjęć.`,
      tooHeavy: `„{name}” waży więcej niż {mb} MB. Zmniejsz je przed wysłaniem.`,
      notImage: `„{name}” nie jest obrazem.`,
      uploadError: `Nie udało się wysłać zdjęć.`,
      removeAria: `Usuń to zdjęcie`,
      deleteTitle: `Usunąć to zdjęcie?`,
      deleteBody: `Agent przestanie je pokazywać, gdy ktoś zapyta o „{amenity}”. Tego nie można cofnąć.`,
      deleteCancel: `Anuluj`,
      deleteConfirm: `Usuń zdjęcie`,
      deleted: `Zdjęcie usunięte`,
      deleteError: `Nie udało się usunąć zdjęcia.`,
      // Orden: el agente solo manda las primeras, por eso se puede arrastrar.
      orderHint: `Agent pokazuje pierwsze {count}. Przeciągnij za uchwyt, aby zmienić kolejność.`,
      dragTitle: `Przeciągnij, aby ustawić kolejność`,
      reordering: `Zapisywanie kolejności…`,
      orderSaved: `Kolejność zapisana`,
      orderError: `Nie udało się zapisać kolejności.`,
      willSend: `Agent wyśle to zdjęcie`,
      wontSend: `Agent nie dojdzie do tego zdjęcia`,
      someFailed: `Nie udało się przetworzyć: {names}`,
    },
  },

  occupancy: {
    question: `Jaką korektę chcą Państwo zastosować?`,
    questionRoom: `Jaką korektę chcą Państwo zastosować do tego pokoju?`,
    modeNone: `Brak`,
    modeReduction: `Obniżka`,
    modeSurcharge: `Dopłata`,
    baseOccupancy: `Obłożenie bazowe`,
    baseHint: `goście (cena standardowa)`,
    thOccupancy: `Obłożenie`,
    thRule: `Reguła`,
    thValue: `Wartość`,
    thActive: `Aktywna`,
    guestsCount: `{count} gość | {count} goście | {count} gości`,
    ruleReductionPct: `Obniżka %`,
    ruleReductionFixed: `Obniżka {currency}`,
    reductionInfo: `Przy mniejszej liczbie gości niż obłożenie bazowe ta obniżka jest stosowana do ceny obiektu.`,
    priceIncludes: `Cena obejmuje`,
    guestsCapacity: `gościa (pojemność pokoju) | gości (pojemność pokoju) | gości (pojemność pokoju)`,
    maxExtraGuests: `Maks. dodatkowych gości`,
    chargePerExtraGuest: `Opłata za dodatkowego gościa`,
    chargeFixed: `{currency} stała`,
    perNight: `za noc`,
    surchargeInfo: `Każdy gość ponad wliczoną pojemność płaci tę opłatę za noc.`,
    noneRoom: `Ten pokój nie ma korekty obłożenia: ta sama cena dla dowolnej liczby gości (w ramach pojemności).`,
    noneBooking: `Ta rezerwacja nie ma korekty obłożenia: ta sama cena dla dowolnej liczby gości (w ramach pojemności).`,
  },

  share: {
    title: `Udostępnij (hotel)`,
    desc: `Ten link dotyczy wyłącznie tego hotelu. Udostępnij go przez WhatsApp lub otwórz jako odwiedzający.`,
    linkLabel: `Link do rezerwacji hotelu`,
    linkHint: `Używaj go w bio, kampaniach lub wiadomościach automatycznych.`,
    viewAsVisitor: `Zobacz jako odwiedzający`,
    tip: `Wskazówka: ten link można wysyłać razem z wiadomością potwierdzającą rezerwację.`,
    noLinkCopy: `Brak linku do skopiowania.`,
    copied: `Link skopiowany.`,
    copyError: `Nie udało się skopiować linku.`,
    noLinkShare: `Brak linku do udostępnienia.`,
    whatsappMsg: `Cześć 👋 Oto link do rezerwacji w tym hotelu: {link}`,
    noLinkOpen: `Brak linku do otwarcia.`,
  },

  unitServices: {
    title: `Wyposażenie i udogodnienia`,
    subPrefix: `Udogodnienia:`,
    thisRoom: `ten pokój`,
    subInfo: `Każdy typ pokoju ma własne; rezerwacja bezpośrednia i agent AI korzystają z udogodnień pokoju przypisanego gościowi.`,
    loading: `Wczytywanie udogodnień…`,
    loadError: `Nie udało się wczytać udogodnień tego pokoju.`,
    retry: `Ponów`,
    saving: `Zapisywanie…`,
    saved: `Zapisano`,
    autosaveHint: `Zmiany zapisują się automatycznie przy zaznaczaniu i odznaczaniu.`,
  },

  welcome: {
    tag: `Silnik rezerwacji bezpośrednich`,
    titleA: `Zdobywaj rezerwacje`,
    titleHighlight: `bez prowizji`,
    sub: `Własny silnik rezerwacji dla każdego obiektu: udostępnij link, a gość rezerwuje i płaci bezpośrednio. Bez pośredników i bez prowizji OTA.`,
    howItWorks: `Jak to działa`,
    benefits: `Korzyści`,
    step1Title: `Udostępnij swój link`,
    step1Text: `Każdy obiekt ma własny link. Opublikuj go na stronie, w mediach społecznościowych lub na WhatsApp; agent AI wysyła go także do zainteresowanych.`,
    step2Title: `Gość rezerwuje`,
    step2Text: `Wybiera daty i płaci w Państwa silniku. Rezerwacja trafia prosto do kalendarza, bez prowizji OTA.`,
    step3Title: `Płatność trafia prosto do Państwa`,
    step3Text: `Otrzymują Państwo płatność bez pośredników i mogą dodać do każdego pobytu promocje, opłaty i usługi dodatkowe.`,
    ctaStart: `Rozpocznij konfigurację`,
    ctaPromotions: `Zobacz promocje globalne`,
    perk1Title: `Zero prowizji OTA`,
    perk1Text: `Zatrzymują Państwo 100% każdej rezerwacji bezpośredniej.`,
    perk2Title: `Natychmiastowa płatność i potwierdzenie`,
    perk2Text: `Gość płaci, a rezerwacja potwierdza się sama.`,
    perk3Title: `Promocje i opłaty dodatkowe`,
    perk3Text: `Rabaty na pobyt, usługi i własne opłaty.`,
    perk4Title: `Jeden link na obiekt`,
    perk4Text: `Każda oferta z własnym silnikiem i dostępnością.`,
  },

  unitsList: {
    title: `Dostępne jednostki`,
    subtitle: `Włącz jednostki, które mają być widoczne w silniku rezerwacji.`,
    loading: `Wczytywanie…`,
    sectionUnits: `Jednostki`,
    colUnit: `Jednostka`,
    colCap: `Poj.`,
    colActive: `Aktywna`,
    noUnits: `Brak skonfigurowanych jednostek.`,
    active: `Aktywna`,
    inactive: `Nieaktywna`,
    noticePrefix: `Włącz rezerwacje bezpośrednie w sekcji`,
    noticeGlobalConfig: `Ustawienia globalne`,
    noticeSuffix: `, aby zarządzać jednostkami.`,
    sectionLink: `Link do pojedynczego apartamentu`,
    linkCardTitle: `Filtrowany link do tego apartamentu`,
    linkCardDesc: `Otwiera ten sam ogólny silnik rezerwacji, ale od razu pokazuje ten apartament.`,
    viewAsVisitor: `Zobacz jako odwiedzający`,
    unitUpdated: `Jednostka zaktualizowana.`,
    updateError: `Nie udało się zaktualizować.`,
    noLinkCopy: `Brak linku do skopiowania.`,
    linkCopied: `Link skopiowany.`,
    copyError: `Nie udało się skopiować linku.`,
    noLinkOpen: `Brak linku do otwarcia.`,
  },

  commonAreaImages: {
    intro: `Zdjęcia ogólne (wejście, basen, recepcja, ogród…) pokazywane gościowi jako okładka po otwarciu silnika, obok galerii każdej jednostki.`,
    imagesCount: `{count} zdjęcie | {count} zdjęcia | {count} zdjęć`,
    reorderHint: `Przeciągnij, aby zmienić kolejność · pierwsze zdjęcie to okładka`,
    reordering: `Zmiana kolejności…`,
    dragTitle: `Przeciągnij`,
    coverBadge: `Okładka`,
    empty: `Nie dodano jeszcze zdjęć części wspólnych. Prześlij je powyżej, aby utworzyć okładkę oferty.`,
    loadError: `Nie udało się wczytać zdjęć części wspólnych.`,
    uploadSuccess: `Zdjęcia przesłane pomyślnie.`,
    uploadError: `Nie udało się przesłać zdjęć.`,
    orderUpdated: `Kolejność zaktualizowana.`,
    orderError: `Nie udało się zaktualizować kolejności.`,
    deleteConfirmMsg: `Usunąć to zdjęcie części wspólnych?`,
    deleteConfirmHeader: `Usuń zdjęcie`,
    deleteAccept: `Usuń`,
    deleteReject: `Anuluj`,
    imageDeleted: `Zdjęcie usunięte.`,
    deleteError: `Nie udało się usunąć zdjęcia.`,
    coverUpdated: `Okładka zaktualizowana.`,
    coverError: `Nie udało się ustawić okładki.`,
    invalidFiles: `Nieprawidłowe pliki: {message}\n{details}`,
  },
};
